import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import PT from 'prop-types';
import { U as UIDContext } from './UIDContext-6eff6071.js';
import { u as uidSafeCharsPropType } from './uidSafeCharsPropType-5b56da59.js';

/*
 Memoizing createUid prevents redundant calls up the react tree.
 */
function createMemoizedUid() {
  let lastParentPrefixer;
  let lastValue;
  let lastUid;
  return function createUid(parentPrefixer, value) {
    if (lastUid === undefined || parentPrefixer !== lastParentPrefixer || value !== lastValue) {
      lastParentPrefixer = parentPrefixer;
      lastValue = value;
      lastUid = parentPrefixer(value);
    }
    return lastUid;
  };
}
class UIDConsumer extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "uid", createMemoizedUid());
  }
  render() {
    const {
      children,
      value
    } = this.props;
    return /*#__PURE__*/React__default.createElement(UIDContext.Consumer, null, prefixer => children(this.uid(prefixer, value)));
  }
}
_defineProperty(UIDConsumer, "propTypes", {
  // eslint-disable-next-line react/require-default-props
  value: uidSafeCharsPropType,
  children: PT.func.isRequired
});
var UIDConsumer$1 = UIDConsumer;

export { UIDConsumer$1 as U };
//# sourceMappingURL=UIDConsumer-89a1c3d5.js.map
